<template>
    <div class="stock-detail">
        <div class="detail-box">
            <Icon type="md-close" class="close" @click="onClose" />
            <div class="material-info">
                <img :src="material.image|default_img" alt="" class="cover-img" />
                <div class="info-container">
                    <div class="title">{{material.name}}</div>
                    <div class="info-item">编号:{{material.no}}</div>
                    <div class="info-item">成分:{{material.component}}</div>
                </div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>面料颜色</th>
                        <th>库存数量(m)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(color,index) in colors" :key="`color-index-${index}`">
                        <td>
                            <div class="color-col">
                                <img :src="color.image|default_img" alt="" class="color-img" />
                                {{ color.name }}
                            </div>
                        </td>
                        <td>2</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    name: "StockDetail",
    props:{
        material:{
            type:Object,
            default:()=>{}
        }
    },
    computed:{
        colors(){
            const {color} = this.material;
            return color || [];
        }
    },
    data(){
        return{}
    },
    mounted(){},
    methods:{
        onClose(){
            this.$emit('close')
        }
    }
}
</script>
<style lang="scss" scoped>
.stock-detail{
    position:fixed;
    top:0;
    left:0;
    z-index:110;
    width:100vw;
    height:100vh;
    background:rgba(0,0,0,0.3);
    display:flex;
    align-items:center;
    justify-content:center;
    .detail-box{
        width:408px;
        background:#fff;
        border-radius:16px;
        padding:0 20px;
        position:relative;
        .close{
            position:absolute;
            top:14px;
            right:14px;
            cursor:pointer;
        }
        .material-info{
            margin-top:30px;
            width:100%;
            display:flex;
            align-items:center;
            column-gap:16px;
            .cover-img{
                width:96px;
                height:96px;
                border-radius:8px;
                border:1px solid #e3e3e3;
            }
            .info-container{
                display:flex;
                align-items:flex-start;
                flex-direction:column;
                .title{
                    color:#333;
                    font-size:14px;
                    font-weight:bold;
                    margin-bottom:10px;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                }
                .info-item{
                    color:#666;
                    font-size:14px;
                    line-height:24px;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                }
            }
        }
        table{
            table-layout: fixed;
            width:100%;
            border-collapse: collapse;
            margin-top:18px;
            margin-bottom:27px;
            border:1px solid #e3e3e3;
            thead tr{
                background:#f6f7fa;
                border:1px solid #e3e3e3;
                th{
                    text-align:center;
                    line-height:32px;
                    padding:5px 0;
                }
            }
            tbody tr{
                border:1px solid #e3e3e3;
                td{
                    text-align:center;
                    color:#333;
                    .color-col{
                        display:flex;
                        align-items:center;
                        column-gap:7px;
                        // padding-left:16px;
                        padding:5px 0 5px 16px;
                        .color-img{
                            width:32px;
                            height:32px;
                            border-radius:4px;
                            border:1px solid #e3e3e3;
                        }
                    }
                }
            }
        }
    }
}
</style>